import React from 'react'

const Media = (props) => {
  const {media} = props;

  let count = -1;
  let list;
  if (media.length >0) {

 list = media.map(item =>{
    count++;

    //Gets type
    const type = item.fields.multimedia.fields.file.contentType
    let mediaElement;

    //Returns element depending on type
    switch (type.substring(0,5)) {
      case 'image':
        mediaElement = <img className="media-pic" alt="Imagen de Eidefut" src={item.fields.multimedia.fields.file.url}/>
        break;
      case 'video':
        mediaElement = <video 
        className="cover" src={item.fields.multimedia.fields.file.url} controls>
        </video>
        break;
      default:
        mediaElement = <img className="cover" alt="Imagen de Eidefut" src={item.fields.multimedia.fields.file.url}/>
        break;
          }

    //Returns mapping element 
    return (
      <div key={count} className="card mx-2 mb-3">
        <div className="card-header">
        {item.fields.titulo}
        </div> 
        <div className="card-body">
         {mediaElement}
        <h6 className="text-center mb-3">{item.fields.multimedia.fields.title}</h6>
        <p className="text-center">{item.fields.descripcion.content[0].content[0].value}</p>
        </div>
      </div>
      )
  })
}else{
    list = <h3>Aún no hay elementos multimedia disponibles</h3>

}

    return (
      <div>
        <h1>Multimedia</h1>
        {list}
      </div>
        );
      }
export default Media;